import { render, staticRenderFns } from "./CaseForm.vue?vue&type=template&id=67deb802&scoped=true&"
import script from "./CaseForm.vue?vue&type=script&lang=ts&"
export * from "./CaseForm.vue?vue&type=script&lang=ts&"
import style0 from "./CaseForm.vue?vue&type=style&index=0&id=67deb802&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67deb802",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
